'use strict';

export class ShowMoreBtn
{
    constructor(options = [])
    {
        this.options = options;
        this.init();
    }

    init()
    {
        const instance = this
        jQuery(document).on('click', '.js-load-more', function(e){
            e.preventDefault()
            let showBtn = jQuery(this)
            instance.showMore(showBtn)
        })
    }

    showMore(showBtn) {
        let itemsContainer = jQuery('.js-items-list')
        let pagenavContainer = jQuery('.js-pagenav-wrap')
        let url = showBtn.attr('data-url')

        if (url !== undefined) {
            jQuery.ajax({
                type: 'GET',
                url: url,
                dataType: 'html'
            }).done(function(data) {
                // удаляем старую навигацию
                jQuery('.js-load-more').remove();

                let elements = jQuery(data).find('.js-item') // элементы
                let pagination = jQuery(data).find('.js-load-more') // кнопка

                itemsContainer.append(elements);
                pagenavContainer.append(pagination);
            });
        }
    }
}